import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  siderWidth: 208,
  pwa: false,
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: {
    header: {
      colorBgHeader: '#F0F0F3',
      colorHeaderTitle: '#1F2633',
      colorTextMenu: '#667085',
      colorTextMenuSelected: '#1F2633',
      colorBgMenuItemSelected: 'transparent',
      heightLayoutHeader: 44,
    },
    sider: {
      colorBgMenuItemSelected: 'rgba(0, 0, 0, 0.06)',
      colorBgMenuItemHover: 'rgba(0, 0, 0, 0.04)',
      colorTextMenuItemHover: '#1F2633',
      colorTextMenuSelected: '#1F2633',
      colorTextMenu: '#667085',
      colorTextMenuActive: '#1F2633',
      colorMenuBackground: '#F0F0F3',
    },
    pageContainer: {
      paddingBlockPageContainerContent: 16,
      paddingInlinePageContainerContent: 16,
      colorBgPageContainer: '#ffffff',
    },
  },
  splitMenus: true,
  suppressSiderWhenMenuEmpty: true,
};
export default Settings;
